import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import StatusChartPanel from './StatusChartPanel';
import { entityType, useTest } from '../../filters/test-filter/TestFilter';
import { siteFilterId, testFilterId, timeRangeFilterId } from '../../filters';

const title = t`Service Test Status`;

function TestStatusPanel() {
    const entity = useTest();
    return <StatusChartPanel entityType={entityType} entity={entity} />;
}

TestStatusPanel.propTypes = {
    ...panelPropTypes,
};

TestStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    minContentHeight: 40,
    contentHeight: 40,
    autoHeight: true,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'TestStatusTrend',
    catalogEntry: {
        category: PANEL_CATEGORIES.TEST,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status trend for a selected service test`,
        previewImage: STATUS_CHART_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeFilterId, testFilterId],
        optional: [siteFilterId],
    },
})(TestStatusPanel);
